module.exports = __webpack_public_path__ + "static/media/wexford-mews.46948c75.pdf";